module.exports = __webpack_public_path__ + "static/media/ve.5a76b249.svg";